/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { Component } from 'react';
import {
    Navbar
} from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import logo from 'Front/assets/img/practice_aid_logo_white.png';
class PagesHeader extends Component {
    constructor(props) {
        super(props);
        this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
        this.state = {
            width: window.innerWidth
        }
    }
    // function that sets the class to active of the active page
    activeRoute(routeName) {
        return window.location.pathname.indexOf(routeName) > -1 ? 'active' : '';
    }
    // function that shows/hides sidebar on responsive
    mobileSidebarToggle(e) {
        document.documentElement.classList.toggle('nav-open');
    }
    updateWidth() {
        this.setState({ width: window.innerWidth });
    }
    componentDidMount() {
        window.addEventListener("resize", this.updateWidth.bind(this));
    }
    render() {
        return (
            <Navbar collapseOnSelect inverse className="navbar-primary navbar-transparent navbar-absolute">
                <Navbar.Header>
                    <Navbar.Brand>
                        {/* <NavLink to={'/login'} className="nav-link"> */}
                        <div className='nav-link'>
                            <img className="frontpage-logo" src={logo} alt="Logo" />
                        </div>
                        {/* </NavLink> */}
                    </Navbar.Brand>
                    <Navbar.Toggle onClick={this.mobileSidebarToggle} />
                </Navbar.Header>
                {/*<Navbar.Collapse>
                    <ul className="nav navbar-nav navbar-right">
                        <li>
                            <NavLink to={'/dashboard'} className="nav-link">
                                <i className="fa fa-th-list"></i>
                                <p>Dashboard</p>
                            </NavLink>
                        </li>
                        <li className={this.activeRoute('login-page')}>
                            <NavLink to={'/login'} className="nav-link">
                                <i className="fa fa-drivers-license-o"></i>
                                <p>Login</p>
                            </NavLink>
                        </li>
                        <li className={this.activeRoute('register-page')}>
                            <NavLink to={'/pages/register-page'} className="nav-link">
                                <i className="fa fa-user-circle-o"></i>
                                <p>Register</p>
                            </NavLink>
                        </li>
                        <li className={this.activeRoute('lock-screen-page')}>
                            <NavLink to={'/pages/lock-screen-page'} className="nav-link">
                                <i className="fa fa-lock"></i>
                                <p>Lock Screen</p>
                            </NavLink>
                        </li>
                    </ul>
                </Navbar.Collapse>*/}
            </Navbar>
        );
    }
}

export default PagesHeader;
